import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Terminal Password'),"outlined":"","hide-details":"auto"},model:{value:(_vm.terminalPassword),callback:function ($$v) {_vm.terminalPassword=$$v},expression:"terminalPassword"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }